/** The DOCX worker started from its bundle under the app's Trusted Types policy (part 22; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { DocxWorker } from './controller.ts';

/** T6, T7: a function starting a DOCX worker (a module worker) for each export. */
export function docxWorker(source: WorkerSource<DocxWorker>): (store: string) => DocxWorker {
  // Part 36a, table BK10: named by the book store it reads, which the worker opens by that name.
  return (store) => new source.Worker(source.trusted(source.url), { type: 'module', name: store });
}
